import { useEffect, memo } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollContainer = document?.querySelector(".content-section");

    if (scrollContainer) {
      scrollContainer?.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      window?.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [pathname]);

  return null;
};

export default memo(ScrollToTop);
